import classnames from 'classnames'
import { Container } from '@sainsburys-tech/luna-grid'
import { IGlobalBar } from '../../../types/Header/IGlobalBar'

function GlobalBar({ element, children, className, label, size, ...rest }: IGlobalBar) {
  const Element = element

  return (
    <Element
      className={classnames('ln-c-header__global-bar', className)}
      aria-label={label}
      {...rest}
    >
      <Container className="ln-c-header__global-bar-inner" size={size}>
        {children}
      </Container>
    </Element>
  )
}

GlobalBar.displayName = 'HeaderGlobalBar'

export default GlobalBar
